import { Injectable } from '@angular/core';
import * as joint from '@clientio/rappid';

import { BasePaper } from './paper/BasePaper';
import { EmptyPaper } from './paper/EmptyPaper';
import { JointJSPaper } from './paper/JointJSPaper';

/**
 * This FlowchartViewService is responsible of serving the paper.
 * Used per FlowchartComponent (not on root).
 * The paper can either be the real paper after init or the empty paper before init
 * @param paper
 */
@Injectable()
export class FlowchartViewService {
  flowchartPaper: BasePaper;

  setJointJsPaper(paper: joint.dia.Paper) {
    this.flowchartPaper = new JointJSPaper(paper);
  }

  /**
   * Returns a Paper based on BasePaper according to current state of the service
   * The Proxy Object decides to return the correct BasePaper.
   */
  getPaper(): BasePaper {
    const handler: ProxyHandler<any> = {
      get: (target: any, prop: string | symbol, receiver: any) => {
        const user = this.flowchartPaper ? this.flowchartPaper : new EmptyPaper();
        return Reflect.get(user, prop, receiver);
      },
    };

    return new Proxy({}, handler) as BasePaper;
  }
}
